export default "__VITE_ASSET__c4c2031b__"